import { getHtml } from "../../../app/rteUtils";
import { PrintPromptLastEssaysViewModel } from "../writingApiSlice";

interface Props {
	promptEssays?: PrintPromptLastEssaysViewModel;
}

export default function PrintLastScoredEssays(props: Props) {
	const getPageMargins = () => {
		return `@page { margin: 40px 50px 40px 50px !important; }`;
	};

	return (
		<div>
			<style>{getPageMargins()}</style>
			{props.promptEssays?.essays.map((essay, index) => (
				<section className="break-after-page divide-y divide-gray-600" key={index}>
					<div className="pb-4">
						<h1>{props.promptEssays?.promptName}</h1>
						<div className="text-sm flex justify-between items-end">
							<div className="grow shrink">
								by{" "}
								<span className="text-base">
									{essay.writerFullName} for {props.promptEssays?.courseName}
								</span>
							</div>
							<div className="pl-4 text-right shrink-0 grow-0">{essay.date}</div>
						</div>
					</div>
					<div
						className="ProseMirror pt-2"
						dangerouslySetInnerHTML={{
							__html: getHtml(
								essay.essayFormat,
								essay.essayContent,
								essay.essayMarkup
							),
						}}></div>
				</section>
			))}
		</div>
	);
}
